// import "@fontsource-variable/alegreya";
import "@fontsource/alegreya/400.css";
import "@fontsource/alegreya/500.css";
import "@fontsource/alegreya/600.css";
import "@fontsource/alegreya/700.css";
import "@fontsource/alegreya-sans/400.css";
import "@fontsource/alegreya-sans/500.css";
import "@fontsource/alegreya-sans/700.css";
import "../styles/main.scss";
import "./features/isi";
// import "./features/cookies";
import "./features/learn_more_modal";
import "./features/hspt_obesity_discussion";
import "bootstrap";
import "./features/menu";
import "./features/geolocation";
console.log("ok");
